import miscService from "../events/misc";

export default {
  install(Vue) {

    Vue.prototype.$misc = miscService;

    Vue.mixin({
      created() {
        if (this.handleLocaleEvent) {
          miscService.addListener("localeEvent", this.handleLocaleEvent);
        }
      },

      destroyed() {
        if (this.handleLocaleEvent) {
          miscService.removeListener("localeEvent", this.handleLocaleEvent);
        }
      }
    });
  }
};
